module.exports = __webpack_public_path__ + "static/080c8cd41f871be0752da3bcc8ff238bd5caf1ceaa26502ed7df49713d389354-82a69edb0fb8d11cfd24a154adff7247.png";